import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=127e123a&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&lang=ts"
export * from "./SignUpForm.vue?vue&type=script&lang=ts"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=127e123a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e123a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127e123a')) {
      api.createRecord('127e123a', component.options)
    } else {
      api.reload('127e123a', component.options)
    }
    module.hot.accept("./SignUpForm.vue?vue&type=template&id=127e123a&scoped=true", function () {
      api.rerender('127e123a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/SignUpForm.vue"
export default component.exports